export default __webpack_public_path__ + "static/media/resume.9b88d344.png";